<template>
  <div>
    <header class="cookie-banner__header">
      <h2>Datenschutzeinstellungen</h2>

      <nav class="cookie-banner__nav">
        <button
          class="button"
          :class="{ 'button--outline': route !== 'options' }"
          @click="setRoute('options')"
        >
          Datenschutzeinstellungen
        </button>

        <button
          class="button"
          :class="{ 'button--outline': route !== 'policy' }"
          @click="setRoute('policy')"
        >
          Cookie-Richtlinie
        </button>
      </nav>
    </header>

    <v-settings-options v-show="route === 'options'" />
    <v-settings-policy v-show="route === 'policy'" />

    <footer class="cookie-banner__footer">
      <button
        class="button"
        @click="acceptAll"
      >
        Akzeptiere alle
      </button>

      <button
        class="button"
        @click="saveSettings"
      >
        Einstellungen speichern
      </button>
    </footer>
  </div>
</template>

<script>
import VSettingsOptions from './VSettingsOptions.vue'
import VSettingsPolicy from './VSettingsPolicy.vue'

import EventBus from '../functions/event-bus.js'

export default {
  name: 'VSettings',

  components: {
    VSettingsOptions,
    VSettingsPolicy
  },

  data () {
    return {
      route: 'options'
    }
  },

  methods: {
    setRoute (name) {
      this.route = name
    },
    acceptAll () {
      EventBus.emit('accept-all')
    },
    saveSettings () {
      EventBus.emit('save-settings')
    }
  }
}
</script>
